export interface AnalyticsEventPayload {
  [key: string]: unknown;
}

const analyticsEnabledFlag = String(
  import.meta.env.VITE_APP_ANALYTICS_ENABLED ?? "false",
).toLowerCase() === "true";

const analyticsValidatedFlag = String(
  import.meta.env.VITE_APP_ANALYTICS_VALIDATED ?? "false",
).toLowerCase() === "true";

const ANALYTICS_ACTIVATED = analyticsEnabledFlag && analyticsValidatedFlag;

export const trackEvent = (
  event: string,
  payload: AnalyticsEventPayload = {},
): void => {
  if (!ANALYTICS_ACTIVATED) {
    if (import.meta.env.DEV) {
      console.debug(`[analytics disabled] ${event}`, payload);
    }
    return;
  }

  if (typeof window === "undefined") {
    return;
  }

  const entry = {
    event,
    category: "achievements",
    timestamp: new Date().toISOString(),
    ...payload,
  };

  if (Array.isArray(window.dataLayer)) {
    window.dataLayer.push(entry);
  } else {
    window.dataLayer = [entry];
  }
};
